import { DeviceState, DeviceMutations, DeviceActions } from '../types'
import api from '../api'
import { DeviceMutationType } from './mutation-types'
import { DeviceActionsType } from './action-types'
import { AxiosError } from 'axios'

const state: DeviceState = {
  errors: false,
  data: [],
  message: '',
  isBusy: false
}

const mutations: DeviceMutations = {
  update (state, payload) {
    state = Object.assign(state, payload)
  },
  isBusy (state, status) {
    state.isBusy = status
  }
}

const actions: DeviceActions = {
  async [DeviceActionsType.getDevices] ({ commit, rootState }) {
    commit(DeviceMutationType.isBusy, true)
    return api.office.getDevices(rootState.auth)
      .then(resp => {
        commit(DeviceMutationType.update, resp)
        commit(DeviceMutationType.isBusy, false)
        return resp
      }).catch((error: AxiosError) => {
        commit(DeviceMutationType.isBusy, false)
        throw error
      })
  },
  async [DeviceActionsType.newDevice] ({ dispatch, rootState }, payload) {
    return api.office.postDevice(rootState.auth, payload)
      .then(resp => {
        dispatch(DeviceActionsType.getDevices)
        return resp
      })
      .catch((error: AxiosError) => {
        throw error
      })
  },
  async [DeviceActionsType.deleteDevice] ({ dispatch, rootState }, id) {
    return api.office.deleteDevice(rootState.auth, id)
      .then(resp => {
        dispatch(DeviceActionsType.getDevices)
        return resp
      })
      .catch((error: AxiosError) => {
        throw error
      })
  },
  async [DeviceActionsType.updateDevice] ({ dispatch, rootState }, payload) {
    const { id, ...rest } = payload
    return api.office.patchDevice(rootState.auth, rest, id)
      .then(resp => {
        dispatch(DeviceActionsType.getDevices)
        return resp
      })
      .catch((error: AxiosError) => {
        throw error
      })
  },
  async [DeviceActionsType.loanDevice] ({ dispatch, rootState }, { patientId, deviceId }) {
    return api.device.loanDevice(rootState.auth, patientId, deviceId)
      .then(resp => {
        dispatch(DeviceActionsType.getDevices)
        return resp
      })
      .catch((error: AxiosError) => {
        throw error
      })
  },
  async [DeviceActionsType.returnDevice] ({ dispatch, rootState }, deviceId) {
    return api.device.returnDevice(rootState.auth, deviceId)
      .then(resp => {
        dispatch(DeviceActionsType.getDevices)
        return resp
      })
      .catch((error: AxiosError) => {
        throw error
      })
  }
}

export const device = {
  state,
  mutations,
  actions
}
